import { Text } from '@procurify/ui'
import styled from 'styled-components'

export const GlobalSearchListItemTitleStyled = styled(Text)`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
